import React from 'react'
import "./OutsourcedCards.css"
import { useNavigate } from 'react-router-dom'

const VCSList = [
    "Forward-looking financial plans and cash-flow forecasts",
    "Data-driven budgets and performance dashboards",
    "Clear, investor-ready financial reporting",
    "Growth planning, risk mitigation, and scenario analysis",
    "Real-time KPI monitoring for rapid decision-making",

  ]
  
  const FSBList = [
    "Daily, weekly, or monthly bookkeeping cycles",
    "End-to-end accounts payable and receivable oversight",
    "Automated expense capture and invoice processing",
    "Timely bank and credit-card reconciliations",
    "Accurate general-ledger upkeep and management reports",

  ]
  
  const PHAList =[
    "Complete payroll processing with on-time tax remittances",
    "Direct deposits and secure e-pay-stub delivery",
    "Year-end T4, T5, and ROE preparation and filing",
    "WSIB, CPP, and EI calculations and submissions",
    "HR support for employee records, benefits, and onboarding",

  ]

  const TCPList = [
    "GST/HST preparation, filing, and remittances",
    "Corporate tax (T2) preparation and compliance monitoring",
    "Owner-manager personal tax (T1) preparation",
    "CRA audit representation and issue resolution",
    "Proactive, customized tax-saving strategies",

  ]
 
  const cardData = [
    {
        heading:"Virtual CFO Services — Strategic Financial Leadership",
        list:VCSList
    },
    {
        heading:"Full-Service Bookkeeping — Your Books, Expertly Managed",
        list:FSBList
    },
    {
        heading:"Payroll & HR Administration — Seamless Payroll, Total Compliance",
        list:PHAList
    },
    {
        heading:"Tax Compliance & Planning — Stay Compliant, Minimize Liability",
        list:TCPList
    }
  ]


function OutsourcedCards() {
    const navigate = useNavigate()
  return (
    <div className='OutsourcedCards-container standard-padding-space'>
        <div className='container my-5'>
            <div className='text-content text-center pb-4'>
                <h3 className='body-heading color-white mb-5'>Our Professional, Modern & Efficient Services</h3>
            </div>

            <div className='row gy-lg-0 gy-4'>
                {
                    cardData.map(ele=>{
                        return(
                            <div className='col-lg-3'>
                                <div className='out-sourced-card-box p-4'>
                                    <img loading="lazy" src='/images/icons/blue-white-tick.png' alt='tick icon' className='mb-3'/>
                                    <h4 className='color-white title'>{ele.heading}</h4>
                                        <ul className='ps-3 mt-3 mb-3'>
                                            {
                                                ele.list.map((point)=>{
                                                    return(
                                                        <li className='body-paragraph mb-2 color-white'>
                                                            {point}
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                </div>
                            </div>
                        )
                    })
                }
            </div>

            <div className='w-100 d-flex mt-4'>
                <button className='blue-btn mt-4 mx-auto' onClick={()=>{navigate("/contact")}}>Learn More About Our Outsourced Accounting Services </button>
            </div>
        </div>
    </div>
  )
}

export default OutsourcedCards